import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAmericanSamoa = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_496)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.8217 1.50525C16.0974 0.54675 14.1127 0 12 0C5.37309 0 0.00084375 5.37178 0 11.9986L8.34783 7.82611L17.8217 1.50525Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12.0014C0.00084375 18.6282 5.37309 24 12 24C14.1127 24 16.0974 23.4533 17.8217 22.4948L8.34783 16.1739L0 12.0014Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.8217 2.12728C18.4994 1.9042 18.1654 1.69673 17.8213 1.50544L0 11.9986V12C0 12 0 12.001 0 12.0014L17.8213 22.4945C18.1655 22.3032 18.4994 22.0958 18.8218 21.8727L2.05416 12L18.8217 2.12728Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.8696 11.5525H19.4402C19.8118 11.1062 19.7889 10.4423 19.3702 10.0237C19.8137 9.58022 19.8137 8.86111 19.3702 8.41753L19.3435 8.44434C19.7869 8.00086 19.8137 7.25494 19.3702 6.81145L12.9457 13.236C13.3892 13.6795 14.0957 13.6742 14.5392 13.2307L14.6629 13.1177L17.7392 12.838V14.1611H18.7826V12.7432L20.3479 12.6009L20.8696 11.5525Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.0439 14.6087L12 14.087L13.0439 13.5652H19.8264V14.6087H13.0439Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_496",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgAmericanSamoa;
